(function () {
  // Disable cross-document View Transitions in in-app browsers.
  // Facebook Messenger / Facebook / Instagram / TikTok WebViews
  // can sometimes fail to paint the destination page and show
  // a completely white screen after navigation.

  if (shouldDisableCrossDocumentViewTransitions()) {
    disableCrossDocumentViewTransitions();
  }

  const viewTransitionRenderBlocker = document.getElementById('view-transition-render-blocker');

  const activation = window.navigation?.activation;

  // A cross-document transition needs an outgoing same-origin document
  // to snapshot, so the first entry of a visit can never have one,
  // and reloads are excluded from navigation:auto.
  const noTransitionPossible =
    !!activation &&
    (activation.from === null || activation.navigationType === 'reload');

  // Remove the render blocker whenever it can't buy a transition.
  if (
    window.matchMedia('(prefers-reduced-motion: reduce)').matches ||
    isLowPowerDevice() ||
    noTransitionPossible
  ) {
    viewTransitionRenderBlocker?.remove();
  } else {
    // Fallback: never keep the page white indefinitely.
    const RENDER_BLOCKER_TIMEOUT_MS = Math.max(0, 1800 - performance.now());

    setTimeout(() => {
      viewTransitionRenderBlocker?.remove();
    }, RENDER_BLOCKER_TIMEOUT_MS);
  }

  const idleCallback =
    typeof requestIdleCallback === 'function'
      ? requestIdleCallback
      : setTimeout;

  window.addEventListener('pageswap', async (event) => {
    const { viewTransition } = event;

    if (shouldSkipViewTransition(viewTransition)) {
      viewTransition?.skipTransition();
      return;
    }

    // Cancel view transition when user interacts.
    ['pointerdown', 'keydown'].forEach((eventName) => {
      document.addEventListener(
        eventName,
        () => {
          viewTransition.skipTransition();
        },
        { once: true }
      );
    });

    // Remove default transition type when landing directly on PDP.
    document
      .querySelectorAll(
        '[data-view-transition-type]:not([data-view-transition-triggered])'
      )
      .forEach((element) => {
        element.removeAttribute('data-view-transition-type');
      });

    const transitionTriggered = document.querySelector(
      '[data-view-transition-triggered]'
    );

    const transitionType =
      transitionTriggered?.getAttribute('data-view-transition-type');

    if (transitionType) {
      viewTransition.types.clear();
      viewTransition.types.add(transitionType);
      sessionStorage.setItem(
        'custom-transition-type',
        transitionType
      );
    } else {
      viewTransition.types.clear();
      viewTransition.types.add('page-navigation');
      sessionStorage.removeItem('custom-transition-type');
    }
  });

  window.addEventListener('pagereveal', async (event) => {
    const { viewTransition } = event;

    if (shouldSkipViewTransition(viewTransition)) {
      viewTransition?.skipTransition();
      return;
    }

    const customTransitionType =
      sessionStorage.getItem('custom-transition-type');

    if (customTransitionType) {
      viewTransition.types.clear();
      viewTransition.types.add(customTransitionType);

      await viewTransition.finished;

      viewTransition.types.clear();
      viewTransition.types.add('page-navigation');

      idleCallback(() => {
        sessionStorage.removeItem('custom-transition-type');

        document
          .querySelectorAll('[data-view-transition-type]')
          .forEach((element) => {
            element.removeAttribute('data-view-transition-type');
          });
      });
    } else {
      viewTransition.types.clear();
      viewTransition.types.add('page-navigation');
    }
  });

  function shouldSkipViewTransition(viewTransition) {
    return (
      !(viewTransition instanceof ViewTransition) ||
      isLowPowerDevice() ||
      prefersReducedMotion() ||
      shouldDisableCrossDocumentViewTransitions()
    );
  }

  // Detect browsers such as Facebook Messenger,
  // Facebook, Instagram and TikTok in-app browsers.
  function shouldDisableCrossDocumentViewTransitions(
    userAgent = navigator.userAgent
  ) {
    const ua = userAgent || '';

    const androidWebView =
      /\bAndroid\b/i.test(ua) &&
      /;\s?wv\)/i.test(ua);

    const knownInAppBrowser =
      /\b(FBAN|FBAV|FB_IAB|FBIOS|Instagram|musical_ly|Bytedance|BytedanceWebview|trill|TikTok)(?:\b|_)/i.test(
        ua
      );

    return androidWebView || knownInAppBrowser;
  }

  // Disable cross-document View Transitions for unsupported
  // in-app browsers so they can never cause a white screen.
  function disableCrossDocumentViewTransitions() {
    // Override Horizon's @view-transition navigation:auto.
    const style = document.createElement('style');

    style.textContent =
      '@view-transition { navigation: none; }';

    (document.head || document.documentElement).appendChild(style);

    // Also remove the render blocker if one exists.
    document
      .getElementById('view-transition-render-blocker')
      ?.remove();
  }

  function prefersReducedMotion() {
    return window.matchMedia(
      '(prefers-reduced-motion: reduce)'
    ).matches;
  }

  function isLowPowerDevice() {
    return (
      Number(navigator.hardwareConcurrency) <= 2 ||
      Number(navigator.deviceMemory) <= 2
    );
  }
})();